import { render, staticRenderFns } from "./ModalEditPatient.vue?vue&type=template&id=34118150&scoped=true"
import script from "./ModalEditPatient.vue?vue&type=script&lang=js"
export * from "./ModalEditPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34118150",
  null
  
)

export default component.exports